import { render, staticRenderFns } from "./index.vue?vue&type=template&id=32ba85bf&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=32ba85bf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ba85bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32ba85bf')) {
      api.createRecord('32ba85bf', component.options)
    } else {
      api.reload('32ba85bf', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=32ba85bf&scoped=true", function () {
      api.rerender('32ba85bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/abnormalOrders/Urgent/index.vue"
export default component.exports